<ngx-spinner [size]="'medium'" [type]="'ball-scale-multiple'" [fullScreen]="true" [zIndex]="999999999" />
